import { createStore } from 'vuex'
import { getFileList, getAIFileList } from '@/api/index'
import { getTxtData, computedData } from '@/utils/index'
import { ElMessage, ElLoading } from 'element-plus'
import fundus from './fundus'
// import img1 from '@/assets/images/1.png'
// import img2 from '@/assets/images/2.png'
// // import img3 from '@/assets/images/3.png'
// // import img4 from '@/assets/images/4.png'
// import img5 from '@/assets/images/5.png'
// import img6 from '@/assets/images/6.jpg'
// import img10 from '@/assets/images/10.jpg'
export default createStore({
  state: {
    user: JSON.parse(window.sessionStorage.getItem('user')) || {},
    ManualList: [], /// 手動的數據
    AIList: [], /// 自動下的數據
    list: [], /// 上传dbfile后返回的数据--頁面顯示的數據，所有数据
    sliceData: {}, /// 每个scan数据
    patientIndex: 0,
    scanIndex: null,
    sliceIndex: null,
    thicknesslist: { /// 厚度数据
      low: [],
      lowp: [],
      cloumn: [],
      cloumnp: []
    },
    findIndex: undefined, /// 如果存在，則刪除按鈕可點擊
    canvasImginfo: {}, /// box最大宽高
    unique: '00020068', /// 批量上傳文件時的標識符-文件夾名+時間戳
    count: 1, /// 記錄AI模式下，當前獲取的第幾批數據，每批20個scan
    refreshData: null, // false
    refreshDataFlag: false, // false
    styleImginfo: {}, /// 图片真实宽高，图片当前显示的宽高（不一定等于box的宽高）
    notListData: false, /// 是否有数据（请求接口后)
    axiosRequest: [], // axios请求的AccessToken函数，用于取消批量上传的接口
    progress: 0, // 数据接口进度条
    progressflag: false,/// 进度条是否显示
    partDataLength: 1000,///分批获取数据的长度
    progressStatus:false
  },
  getters: {
    getUserInfo (state) {
      let obj = {}
      if (state.list.length !== 0) {
        obj = {
          ...state.sliceData.userInfo,
          laterality: state.sliceData.list[state.sliceIndex].laterality
        }
      }
      return obj
    },
    getdrawList (state) {
      // console.log('getdrawList', state.sliceData.list[state.sliceIndex].drawList)
      return state.sliceData.list[state.sliceIndex].drawList
    },
    getMarkList (state) {
      return state.sliceData.list[state.sliceIndex].markList
    },
    getScanNumTotal (state) {
      return state.list.length !== 0 ? state.list[state.patientIndex].scanlist.length : 0
    },
    getPatientTotal (state) {
      return state.list.length !== 0 ? state.list.length : 0
    },
    getDiagnosis (state) {
      return state.list.length !== 0 ? state.sliceData.list[state.sliceIndex].diag : []
    },
    getPoorQuality (state) {
      return state.list.length !== 0 ? state.sliceData.list[state.sliceIndex].poorQuality : false
    },
    getApproveStatus (state) {
      return state.list.length !== 0 ? state.sliceData.list[state.sliceIndex].approved : false
    },
    getEditAndSavedStatus (state) {
      if (state.list.length !== 0) {
        console.log(state.sliceData.list[state.sliceIndex].editStatus, !state.sliceData.list[state.sliceIndex].saveStatus)
        if (state.sliceData.list[state.sliceIndex].editStatus && !state.sliceData.list[state.sliceIndex].saveStatus) { // 修改未保存
          return true
        } else {
          return false
        }
      }
    },
  },
  mutations: {
    setUser (state, payload) {
      if (payload) {
        state.user = payload
        const user = JSON.stringify(payload)
        window.sessionStorage.setItem('user', user)
      }
    },
    setaxiosRequest (state, payload) {
      if (payload) {
        state.axiosRequest.push(payload)
      }
    },
    clearaxiosRequest (state) {
      state.axiosRequest = []
    },
    setrefreshData (state, payload) {
      if (payload) {
        state.refreshData = payload
      }
    },
    setrefreshDataFlag (state, payload) {
      state.refreshDataFlag = payload
      if (!payload) {
        state.refreshData = null
      }
    },
    /// 添加标注
    insertDrawList (state, payload) {
      if (payload) {
        state.sliceData.list[state.sliceIndex].drawList.push(payload)
        /// 保存和修改狀體位
        state.sliceData.list[state.sliceIndex].editStatus = true
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].editStatus = true
        state.sliceData.list[state.sliceIndex].saveStatus = false
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = false
      }
    },
    // 修改或删除标注
    spliceDrawList (state, payload) {
      // console.log('payload.i', payload.i)
      if (payload.data) {
        state.sliceData.list[state.sliceIndex].drawList.splice(payload.i, 1, payload.data)
        /// 保存和修改狀體位
        state.sliceData.list[state.sliceIndex].editStatus = true
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].editStatus = true
        state.sliceData.list[state.sliceIndex].saveStatus = false
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = false
      } else {
        state.sliceData.list[state.sliceIndex].drawList.splice(payload.i, 1)
        /// 保存和修改狀體位
        state.sliceData.list[state.sliceIndex].editStatus = true
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].editStatus = true
        state.sliceData.list[state.sliceIndex].saveStatus = false
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = false
      }
    },
    /// 切換病患
    changePatient (state, payload) {
      if (state.list !== [] && state.list.length !== 0) {
        state.scanIndex = 0
        state.sliceIndex = 0
        state.patientIndex = payload || 0
        state.sliceData = state.list[state.patientIndex].scanlist[state.scanIndex]
      }
    },
    /// 切换scan图片
    changeScan (state, payload) {
      if (state.list !== [] && state.list.length !== 0) {
        const options = {
          lock: true,
          text: 'Loading...',
          customClass: 'customClass',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        }
        const loading = ElLoading.service(options)
        const idx2 = state.refreshData ? state.refreshData.sliceIndex : 0
        state.scanIndex = payload || 0
        state.sliceData = state.list[state.patientIndex].scanlist[state.scanIndex]
        const idx21 = state.list[state.patientIndex].scanlist[state.scanIndex].index - 1
        state.sliceIndex = state.refreshDataFlag ? idx2 : idx21
        state.refreshDataFlag = false
        state.sliceData.list.forEach((item, index) => {
          if (item.styleImg.width) {
            const list = []
            item.drawList.forEach((item2, index2) => {
              const da = computedData(item2, 1, item.styleImg)
              list.push(da)
            })
            state.sliceData.list[index].markList = list
            state.list[state.patientIndex].scanlist[state.scanIndex].list[index].markList = list
          }
        })
        state.thicknesslist = state.list[state.patientIndex].scanlist[state.scanIndex].list[0].thicknesslist
        setTimeout(() => {
          loading.close()
        }, 500)
      } else {
        state.scanIndex = 0
        state.sliceIndex = 0
        state.sliceData = {}
        state.thicknesslist = []
      }
    },
    setMarkList (state) {
      if (state.canvasImginfo.width) {
        state.sliceData.list.forEach((item, index) => {
          const list = []
          item.drawList.forEach((item2, index2) => {
            const da = computedData(item2, 1, item.styleImg)
            list.push(da)
          })
          state.sliceData.list[index].markList = list
          state.list[state.patientIndex].scanlist[state.scanIndex].list[index].markList = list
          // console.log('setMarkList', list)
        })
      }
    },
    changeSliceIndex (state, payload) {
      state.sliceIndex = payload.index
      state.thicknesslist = state.sliceData.list[payload.index].thicknesslist
    },
    changeSlicedata (state, payload) {
      state.sliceData.list[payload.index].drawList = payload.drawlist
      state.list[state.patientIndex].scanlist[state.scanIndex].list[payload.index].drawList = payload.drawlist
      // console.log('state.sliceIndex', state.sliceIndex)
    },
    /// 写入list
    setList (state, payload) {
      if (payload.type === 0) { /// 手動下
        state.ManualList = payload.list
      } else { // 自動下
        state.AIList = payload.list
        if (!payload.start || payload.start == 1) {
          state.patientIndex = 0
          state.scanIndex = 0
          state.sliceIndex = 0
        }

      }
      state.list = payload.list
      console.log(state.list)
    },
    /// 将页面转换后的mark坐标转存到sliceData和list中
    copyMarkList (state, payload) {
      state.list[state.patientIndex].scanlist[state.scanIndex].list[payload.index].markList = payload.data
      state.sliceData.list[payload.index].markList = payload.data
      console.log('sliceData', state.sliceData)
    },
    setcanvasImginfo (state, payload) {
      state.canvasImginfo = payload
    },
    /// 将页面转换后的mark坐标转存到sliceData和list中
    pushMarkList (state, payload) {
      state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].markList.push(payload)
      state.sliceData.list[state.sliceIndex].markList.push(payload)
      console.log('sliceData', state.sliceData)
    },
    setUnique (state, payload) {
      if (payload) {
        state.unique = payload
      }
    },
    setfindIndex (state, payload) {
      state.findIndex = payload
    },
    /// 手動模式且已經上傳過文件，切換tab時，顯示保留的手動模式下的數據
    changeListToManualList (state) {
      state.list = state.ManualList
      state.patientIndex = 0
      state.scanIndex = 0
      state.sliceIndex = 0
      if (state.list.length === 0) {
        state.sliceData = []
        state.thicknesslist = []
      }
    },
    /// 存儲切片的diagnosis情況
    pushDiagnosis (state, payload) {
      if (state.list.length !== 0) {
        state.sliceData.list[state.sliceIndex].diag = payload
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].diag = payload
        /// 保存和修改狀體位
        state.sliceData.list[state.sliceIndex].editStatus = true
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].editStatus = true
        state.sliceData.list[state.sliceIndex].saveStatus = false
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = false
      }
    },
    setApproveStatus (state, payload) {
      if (state.list.length !== 0) {
        state.sliceData.list[state.sliceIndex].approved = payload
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].approved = payload
        /// 保存和修改狀體位
        state.sliceData.list[state.sliceIndex].editStatus = true
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].editStatus = true
        state.sliceData.list[state.sliceIndex].saveStatus = false
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = false
      }
    },
    setCount (state, payload) {
      state.count = payload
    },
    setSaveStatus (state, payload) {
      if (state.list.length !== 0) {
        state.sliceData.list[state.sliceIndex].saveStatus = payload
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = payload
      }
    },
    setImgStyleInfo (state, payload) {
      if (state.list.length !== 0) {
        state.sliceData.list[state.sliceIndex].styleImg = payload
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].styleImg = payload
      }
    },
    setImgStyleInfo2 (state, payload) {
      if (state.list.length !== 0) {
        state.sliceData.list[payload.index].styleImg = payload.list
        state.styleImginfo = payload.list/// 由于后期需求不需要等比例放大，不介意图片被拉伸，所以传入数据改为：图片真实宽高以及box的大小，不是按比例宽高
        state.list[state.patientIndex].scanlist[state.scanIndex].list[payload.index].styleImg = payload.list

        const list = []
        state.sliceData.list[payload.index].drawList.forEach((item2, index2) => {
          const da = computedData(item2, 1, state.sliceData.list[payload.index].styleImg)
          list.push(da)
        })
        state.sliceData.list[payload.index].markList = list
        state.list[state.patientIndex].scanlist[state.scanIndex].list[payload.index].markList = list
      }
    },
    /// 修改poorQuality状态
    setpoorQualityStatus (state, payload) {
      if (state.list.length !== 0) {
        state.sliceData.list[state.sliceIndex].poorQuality = payload
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].poorQuality = payload
        /// 保存和修改狀體位
        state.sliceData.list[state.sliceIndex].editStatus = true
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].editStatus = true
        state.sliceData.list[state.sliceIndex].saveStatus = false
        state.list[state.patientIndex].scanlist[state.scanIndex].list[state.sliceIndex].saveStatus = false
      }
    }
  },
  actions: {
    /// 獲取頁面數據--自動模式下的--返回格式按scan封裝
    async getAIListData (ctx, params) {
      // const options = {
      //   lock: true,
      //   text: 'Loading...',
      //   customClass: 'customClass',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // }
      // const loading = ElLoading.service(options)
      try {
        if(params.start===1){ctx.state.progressStatus=true}else{ctx.state.progressStatus=false}
        const { code, data:resdata } = await getAIFileList(params)
        let ret = {}
        const list = []
        let totalCount=resdata.count
        let data=resdata.scanResultVoList
        console.log(resdata,data)
        if (Number(code) === 200) {
          if (data.length !== 0) {
            let scanList=[]
           
            for (let i = 0; i < data.length; i++) {
              const sliceList = []
              for (let l = 0; l < data[i].scanResult.slice.length; l++) {
                const da = data[i].scanResult.slice
                const drawlist = []
                let diag = {}
                let approved = false
                if (da[l].fileData !== '' && da[l].fileData) { /// 解析標註框數據，後端直接返回文檔內容
                  const ret2 = getTxtData(da[l].fileData)
                  // console.log('ret', ret2)
                  if (ret2) {
                    diag = ret2.diagnosis
                    drawlist.push(...ret2.list)
                    approved = ret2.approved
                  }
                }
                const styleImg = {}
                const sliceobj = {
                  url: `https://iris-test.jy-meditech.com:8010/${da[l].pngUrl}`,
                  markUrl: da[l].url,
                  markCont: da[l].fileData,
                  thicknesslist: {
                    low: da[l].low ? da[l].low : [],
                    lowp: da[l].lowp ? da[l].lowp : [],
                    cloumn: da[l].cloumn ? da[l].cloumn : [],
                    cloumnp: da[l].cloumnp ? da[l].cloumnp : [],
                    avgThickness: da[l].avgThickness,
                    totalVolume: da[l].totalVolume
                  },
                  fileName: da[l].fileName,
                  laterality: da[l].laterality,
                  type: da[l].type,
                  uniqueId: da[l].uniqueId,
                  updateDoctorName: da[l].updateDoctorName,
                  findings: da[l].findings,
                  drawList: drawlist,
                  markList: [],
                  approved: approved, /// 当前AI诊断，是否approve
                  diag: diag,
                  editStatus: false, /// 是否修改標志位
                  saveStatus: false, // 是否保存標識位
                  pngFileName: da[l].pngFileName,
                  styleImg: styleImg,
                  poorQuality: da[l].poorQuality === 1
                }
                sliceList.push(sliceobj)
              }
              const userInfo = {
                preFixName: data[i].scanResult.preFixName,
                name: data[i].scanResult.name,
                birthDate: data[i].scanResult.birthday,
                sex: data[i].scanResult.sex, /// 左右眼
                ID: data[i].scanResult.initId,
                patientId: data[i].scanResult.patientId,
                scanDate: data[i].scanResult.modifyTime
              }
              const scanobj = {
                userInfo: userInfo,
                img: `https://iris-test.jy-meditech.com:8010/${data[i].scanResult.img}`,
                list: sliceList,
                index: data[i].sliceIndex <= sliceList.length ? data[i].sliceIndex : Math.ceil(sliceList.length / 2)
              }
              scanList.push(scanobj)
            }
            ///数据量太大分批获取并插入
            let scanListPart = []
            let have_part=[]
            if (params.start === 1) {//重新查询
              scanListPart = new Array(totalCount)
              have_part=[]
            } else {///插入查询
              scanListPart = ctx.state.list[ctx.state.patientIndex].scanlist ? ctx.state.list[ctx.state.patientIndex].scanlist : new Array(totalCount)
              have_part=ctx.state.list[ctx.state.patientIndex].have_data_part ? ctx.state.list[ctx.state.patientIndex].have_data_part :[]
            }
            if (!scanListPart[params.start - 1]) {
              scanListPart.splice((params.start - 1), params.length, ...scanList)
            }
            have_part.push({start:params.start,length:params.length})
            console.log('scanListPart2222',scanListPart,params.start)
            ///
            const listobj = {
              have_data_part: [...new Set(have_part.map(t => JSON.stringify(t)))].map(s => JSON.parse(s)),///已有数据的part
              scanlist: scanListPart
            }
            list.push(listobj)
            ret = {
              type: 1,
              list: list,
              totalCount: totalCount,
              start: params.start,
              length:params.length
            }
            ctx.commit('setList', ret)
            if (data.length !== 0 && params.start === 1) {
              console.log('params.startparams.start',params.start)
              const idx = ctx.state.refreshData ? ctx.state.refreshData.scanIndex : 0
              // const idx2 = ctx.state.refreshData ? ctx.state.refreshData.sliceIndex : 0
              ctx.commit('changeScan', idx)
              ctx.commit('setrefreshDataFlag', false)
            }
            ctx.state.notListData = false
          } else {
            ret = {
              type: 1,
              list: []
            }
            ctx.commit('setList', ret)
            ctx.commit('changeScan')
            ctx.state.notListData = true
          }
          console.log('ctx.state.list',ctx.state.list)
        } else if (code === 402) {
          ElMessage({
            type: 'error',
            message: 'token 失效'
          })
        }
      } catch (error) {
        console.log(error)
      }
      // loading.close()
    },

    /// 获取页面数据---手動模式下--返回格式按病患封裝
    async getListData (ctx, params) {
      const { code, data } = await getFileList(params)
      console.log('data', data)
      const list = []
      if (Number(code) === 200) {
        if (data.length !== 0) {
          for (let i = 0; i < data.length; i++) {
            const scanList = []
            for (let j = 0; j < data[i].scanResultList.length; j++) {
              const da = data[i].scanResultList[j].slice
              const sliceList = []
              for (let l = 0; l < da.length; l++) {
                const drawlist = []
                let diag = {}
                let approved = false
                if (da[l].fileData !== '' && da[l].fileData) { /// 解析標註框數據，後端直接返回文檔內容
                  const ret2 = getTxtData(da[l].fileData)
                  // console.log('ret', ret)
                  if (ret2) {
                    diag = ret2.diagnosis
                    drawlist.push(...ret2.list)
                    approved = ret2.approved
                  }
                }
                const styleImg = {}
                const sliceobj = {
                  url: `https://iris-test.jy-meditech.com:8010/${da[l].pngUrl}`,
                  markUrl: da[l].url,
                  markCont: da[l].fileData,
                  thicknesslist: {
                    low: da[l].low ? da[l].low : [],
                    lowp: da[l].lowp ? da[l].lowp : [],
                    cloumn: da[l].cloumn ? da[l].cloumn : [],
                    cloumnp: da[l].cloumnp ? da[l].cloumnp : [],
                    avgThickness: da[l].avgThickness,
                    totalVolume: da[l].totalVolume
                  },
                  fileName: da[l].fileName,
                  laterality: da[l].laterality,
                  type: da[l].type,
                  uniqueId: da[l].uniqueId,
                  updateDoctorName: da[l].updateDoctorName,
                  findings: da[l].findings,
                  drawList: drawlist,
                  markList: [],
                  approved: approved, /// 当前AI诊断，是否approve
                  diag: diag,
                  editStatus: false, /// 是否修改標志位
                  saveStatus: false, // 是否保存標識位
                  pngFileName: da[l].pngFileName,
                  styleImg: styleImg,
                  poorQuality: da[l].poorQuality === 1
                }
                sliceList.push(sliceobj)
              }
              const userInfo = {
                preFixName: data[i].scanResultList[j].preFixName,
                name: data[i].name,
                birthDate: data[i].birthday,
                sex: data[i].sex, /// 左右眼
                ID: data[i].initId,
                patientId: data[i].patientId,
                scanDate: data[i].scanResultList[j].modifyTime
              }

              const scanobj = {
                // img: `http://103.227.33.150:8010/${data[i].scanResultList[j].img}`,
                img: `https://iris-test.jy-meditech.com:8010/${data[i].scanResultList[j].img}`,
                list: sliceList,
                userInfo: userInfo,
                index: Math.ceil(sliceList.length / 2)
              }
              scanList.push(scanobj)
            }
            // const userInfo = {
            //   name: data[i].name,
            //   birthDate: data[i].birthday,
            //   sex: data[i].sex, /// 左右眼
            //   ID: data[i].initId,
            //   scanDate: data[i].scanDate
            // }
            // console.log('i', i)

            // scanList[i].userInfo = userInfo
            const listobj = {
              scanlist: scanList
            }
            console.log('i', scanList)
            list.push(listobj)
          }
        }
        const ret = {
          type: 0,
          list: list
        }
  
        console.log('ctx', list)
        ctx.commit('setList', ret)
        ctx.commit('changeScan')
      } else if (code === 402) {
        ElMessage({
          type: 'error',
          message: 'token 失效'
        })
      }
      
    },

    /// 切换slice时，如果drawlist为空，则请求txt档获取数据
    async getSliceData (ctx, payload) {
      // const li = ctx.state.sliceData.list[payload]

      // let drawlist = []
      // let diag = {}
      // // console.log('li.drawlist.length !== 0 && ', li, payload)

      // if (li.drawlist !== [] && li.markUrl) {
      //   if (li.markUrl.AIUrl !== '') {
      //     const res = await txtData(li.markUrl.AIUrl)
      //     const ret1 = getTxtData(res)
      //     if (ret1) {
      //       diag = ret1.diagnosis
      //       drawlist = [...ret1.list]
      //     }
      //   }
      //   if (li.markUrl.AutoUrl !== '') {
      //     const res = await txtData(li.markUrl.AutoUrl)
      //     const ret2 = getTxtData(res)
      //     // console.log('ret', ret)
      //     if (ret2) {
      //       diag = ret2.diagnosis
      //       drawlist.push(...ret2.list)
      //     }
      //   }

      //   // const marklist = []
      //   const obj = {
      //     index: payload,
      //     diag: diag,
      //     drawlist: drawlist
      //   }
      //   console.log('obj', obj)

      //   ctx.commit('changeSlicedata', obj)
      // } else {
      const obj = {
        index: payload
      }
      ctx.commit('changeSliceIndex', obj)
      // }
    }
  },
  modules: {
    fundus
  }
})
